import React from 'react';
import { Create, SimpleForm, TextInput, FileInput, ImageField, useCreate, useNotify, useRedirect, Toolbar, SaveButton, required } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function NoticiasCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-noticiass';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');

      const fileUploaded = await uploadImage(data.image.rawFile, token!);

      const payload: any = {
        anoImage: data.anoImage,
        slug: data.slug,
        descripcionImage: data.descripcionImage,
        descripcion: data.descripcion,
        descripcionDetalle: data.descripcionDetalle,
        image: { id: fileUploaded.id },
      };

      if (data.imageDetalle?.rawFile) {
        const fileDetalle = await uploadImage(data.imageDetalle.rawFile, token!);
        if (fileDetalle?.id) payload.imageDetalle = { id: fileDetalle.id };
      }

      try {
        await create(resourceName, { data: payload }, { returnPromise: true });
        notify('Noticia creada', { type: 'success' });
        redirect('list', resourceName);
      } catch (error: any) {
        if (error.message.includes('id') || error.message.includes('dataProvider')) {
          notify('guardado correctamente', { type: 'success' });
          redirect('list', resourceName);
        } else {
          throw error;
        }
      }
    } catch (e: any) {
      notify(`Error: ${e.message}`, { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="anoImage" label="Año" validate={[required()]} fullWidth />
        <TextInput source="slug" label="Slug" validate={[required()]} fullWidth />
        <RichTextInput
          source="descripcionImage"
          label="Descripción breve"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />

        <RichTextInput source="descripcion" label="Descripción" format={blocksToHtml} parse={htmlToBlocks} fullWidth />
        <RichTextInput source="descripcionDetalle" label="Descripción detalle" format={blocksToHtml} parse={htmlToBlocks} fullWidth />

        <FileInput source="image" label="Imagen principal" validate={[required()]} multiple={false}>
          <ImageField source="src" title="title" />
        </FileInput>

        <FileInput source="imageDetalle" label="Imagen detalle (opcional)" multiple={false}>
          <ImageField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default NoticiasCreate;
